import { render, staticRenderFns } from "./yuyueArrival.vue?vue&type=template&id=76c0f7c8&scoped=true&"
import script from "./yuyueArrival.vue?vue&type=script&lang=js&"
export * from "./yuyueArrival.vue?vue&type=script&lang=js&"
import style0 from "./yuyueArrival.vue?vue&type=style&index=0&id=76c0f7c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c0f7c8",
  null
  
)

export default component.exports